import Vue from "vue";
import Router from "vue-router";
import layout from "./layout";
import home from "./home";
import firebase from 'firebase/app'
import 'firebase/analytics';

let routeList = [];
let routes = routeList.concat(layout, home);
const router = new Router({
  mode: "history",
  routes
});

router.beforeEach((to, from, next) => {
  firebase.analytics().logEvent("screen_view", {
    screen_name: to.name,
    page_location: to.fullPath
  });
  Vue.$cookies.remove("institution");
  if (Object.keys(to.query).length != 0) {
    if (to.query.institution) {
      Vue.$cookies.set("institution", to.query.institution);
      Vue.$cookies.set(
        "image",
        `https://storage.googleapis.com/viewmed-static/branding/${to.query.institution
        }.png`
      );
      // next({ path: to.path });
    }
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    //solo este if es lo que se agrega
    if (!sessionStorage.getItem("user")) {
      next({ path: "/" });
    } else {
      next();
    }
  }
  if (to.meta && to.meta.requireRole) {
    if (to.meta.requireRole[0] === sessionStorage.getItem("role")) {
      next();
    } else {
      alert("Wrong");
      next("/profile/" + sessionStorage.getItem("role") + "/");
    }
  } else {
    next();
  }
});

Vue.use(Router);

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js